/* eslint-disable no-useless-escape */
/* global require, module */

import { translate } from '@openclassrooms/translations';
import browser from '@openclassrooms/utils/browser';

function myFactory($, modernizr, pubsub, responsiveService, i18nService) {
  if (!$.OC || (!$.OC.baseWidget && !responsiveService)) {
    if (!$.widget) {
      if (browser.isBrowser()) {
        // eslint-disable-next-line no-console
        console.warn('jquery ui is not available in this context');
      }
      return null;
    }

    $.widget('OC.baseWidget', {
      _parseStringOptions: function (optionsString) {
        var match,
          options = {};

        optionsString = $.trim(optionsString);

        match = optionsString.match(/([a-zA-Z0-9]+).*?:.*?('.*?'|\[.*?\]|true|false|[0-9\.]+)/g);

        match.forEach(function (group) {
          var tmp,
            arr,
            option = group.match(/(.*?):(.*)/),
            val = $.trim(option[2]),
            key = $.trim(option[1]),
            arrayMatch = val.match(/^\[.*?\]/),
            parse = function (val) {
              var stringMatch = val.match(/'(.*)'/),
                boolMatch = val.match(/true|false/),
                numMatch = !isNaN(val);

              if (stringMatch) {
                val = stringMatch[1];
              } else if (boolMatch) {
                val = val === 'true';
              } else if (numMatch) {
                val = parseFloat(val);
              }

              return val;
            };

          if (arrayMatch) {
            arr = [];
            tmp = val.match(/'.*?'|true|false|[0-9\.]+/g);
            tmp.forEach(function (item) {
              arr.push(parse(item));
            });
            val = arr;
          } else {
            val = parse(val);
          }

          options[key] = val;
        });

        return options;
      },

      _getCreateOptions: function () {
        var options = {},
          tmp;

        this._super();

        if (this.element.length) {
          tmp = this.element.data('options');

          if (tmp) {
            // options are set with jquery.data() in the element
            if ($.isPlainObject(tmp)) {
              options = tmp;

              // you can pass parameters in a data-options attribute
              // this is the prefered method to pass in arguments in html
              // ex: data-options="classnameToToggle: 'search-panel--opened',target: '#search-panel'"
            } else {
              options = this._parseStringOptions(tmp);
            }
          }

          // get options from data-option attribute
          // options can be passed like this:
          // data-option_my-option="test" -> will become 'options.myOption' set to "test"
          $.each(this.element.data(), function (key, value) {
            var match = key.match(/^option_(.*)/);
            if (match) {
              options[match[1]] = value;
            }
          });
        }

        return options;
      },

      _create: function (widgetName) {
        this._super();

        this.isDisabled = false;

        this.baseClassName = this._getBaseClassName(widgetName);

        this.responsiveService = responsiveService;

        this.i18nService = i18nService
          ? i18nService
          : function str() {
              return str;
            };

        this.elements = {};
        this.elements.$container = this.element;

        // make the widget easily accessible from outside
        this.element[0]._widget = this;

        if (this.options.classname) {
          this.element.addClass(this.options.classname);
        }

        this.element.attr('data-widget', this.widgetName);
      },

      _getBaseClassName: function (baseClassName) {
        if (!baseClassName) {
          return '';
        }

        if (!baseClassName.match(/^js\-/)) {
          baseClassName = 'js-' + baseClassName;
        }
        return baseClassName;
      },

      _: translate,

      getClickEventName: function () {
        return this.isTouch() ? 'tap' : 'click';
      },

      registerResponsiveChange: function () {
        var self = this;
        if (pubsub) {
          pubsub.subscribe(
            responsiveService.EVENT_RESPONSIVE_BREAKPOINT_CHANGE,
            function (eventName, data) {
              self.onResponsiveChange(data.width);
            }
          );
        }
      },

      onResponsiveChange: $.noop,

      isTouch: function () {
        return modernizr.touchevents;
      },

      getWidgetElement: function (elementName) {
        var element;

        if (elementName.match(/^\$/)) {
          element = this.elements[elementName];
        } else {
          element = this.element.find('.' + this.baseClassName + '-' + elementName);
        }

        return element || $();
      },

      disable: function () {
        this.element.addClass('is-disabled');
        this.isDisabled = true;
      },

      enable: function () {
        this.element.removeClass('is-disabled');
        this.isDisabled = false;
      },
    });
  }

  return $.OC.baseWidget;
}

(function (root, factory) {
  'use strict';

  // used by non commonjs / es6 modules
  if (window._define) {
    window._define('widgets/baseWidget', ['jquery', 'Modernizr'], factory);
  }
})(this, myFactory);

export default myFactory(
  require('jquery'),
  window.Modernizr,
  window.PubSub,
  require('../Services/responsive'),
  require('@openclassrooms/translations').default
);
